import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { homePath, pageChangeTimeout } from '../globalUtils';
import usePageStore from '../Page/pageStore';
import useDataStore from '../Data/dataStore';
import useMenuStore from '../Menu/menuStore';
const getPage = (urlPath) => urlPath?.split('/').filter(Boolean).pop() ?? '';
export const getPath = (path) => getPage(path) || homePath;
export const scrollToTop = { behavior: 'instant', top: 0 };
const Router = () => {
    const { blockSnap, shownPage } = usePageStore();
    const pageContent = useDataStore((state) => state.data[shownPage]?.page_sections);
    const inited = useRef(false);
    const urlPath = useLocation().pathname;
    const timeout = useRef(0);
    const currentPage = useRef('');
    const mounted = useRef(false);
    useEffect(() => {
        if (pageContent && !inited.current) {
            inited.current = true;
            if (useDataStore.getState().data?.[shownPage]?.snap) {
                document.documentElement.style.scrollSnapType = 'y mandatory';
            }
        }
    }, [pageContent]);
    useEffect(() => {
        document.documentElement.style.scrollSnapType = 'none';
        const newPath = getPath(urlPath);
        usePageStore.getState().setActivePage(newPath);
        usePageStore.getState().setShownSection(-1);
        usePageStore.getState().setActiveSection(-1);
        usePageStore.getState().setBlockSnap(blockSnap + 1);
        useMenuStore.getState().setOpen(false);
        currentPage.current = newPath;
        clearTimeout(timeout.current);
        timeout.current = window.setTimeout(registerNewPage, !mounted.current ? 0 : pageChangeTimeout * 1000);
        mounted.current = true;
    }, [urlPath]);
    const registerNewPage = () => {
        window.scrollTo(scrollToTop);
        if (useDataStore.getState().data?.[currentPage.current]?.snap) {
            document.documentElement.style.scrollSnapType = 'y mandatory';
        }
        usePageStore.getState().setShownPage(currentPage.current);
    };
    return null;
};
export default Router;
